module.exports = __webpack_public_path__ + "img/tel_icon.a15e1aff.png";